/**
 * 分割供給の 30 分コマの値 (kWh/30 分、 0 以上の整数。 BP 標準 JP06357 N(9)) の画面モデル。
 * 判断の正は backend の entity で、 ここの検査は入力中に理由を出すための事前チェック。
 */

/** 通告値の上限 (BP 標準 JP06357 N(9))。 */
export const MAX_SLOT_VALUE = 999_999_999

/**
 * セル文字列を 0 以上の整数にする (前後の空白と桁区切りの ',' を除く)。
 * 空・負・小数・999,999,999 超・数字以外は undefined。
 */
export function parseSlotValue(raw: string): number | undefined {
  const text = raw.trim().replace(/,/g, '')
  if (!/^\d+$/.test(text)) return undefined
  const n = Number(text)
  return n <= MAX_SLOT_VALUE ? n : undefined
}
